import { render, staticRenderFns } from "./SelfieVerifysrcHV.vue?vue&type=template&id=23601b20"
import script from "./SelfieVerifysrcHV.vue?vue&type=script&lang=js"
export * from "./SelfieVerifysrcHV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports